export default "__VITE_ASSET__DtyBafT___"